import React from 'react'
import { LayoutRoute } from 'components/Layout';
import { default as HomePublicaLayout } from 'components/Layout/HomePublica';
import MarineEmisionContratante from 'containers/MarineInland/MarineEmisionContratante';
import MarineEmisionVigencia from 'containers/MarineInland/MarineEmisionVigencia';
import MarineDatosLead from 'containers/MarineInland/MarineInlandDatosLead';
import MarineInlandInfoadicionalEquipos from 'containers/MarineInland/MarineInlandInfoadicionalEquipos';
import MarineDatosMaquinaria from 'containers/MarineInland/MarineInlandMaquinaria';
import MarineDatosResumen from 'containers/MarineInland/MarineInlandResumen';
import MarineRecuperarCotizacion from 'containers/MarineInland/RecuperarMarineInland';
import { MarineInland } from 'containers/MarineInland/constantes/general';

const MARINE_ROUTES = [
  <LayoutRoute
    exact={true}
    path={`${MarineInland.urls.datosLead}/:idCotizacion?`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={MarineDatosLead}
    validations={{
      prePolizaPagada: true,
    }}
  />,
  <LayoutRoute
    exact={true}
    path={`${MarineInland.urls.ingresoEquipos}/:idCotizacion?`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={MarineDatosMaquinaria}
    validations={{
      prePolizaPagada: true,
    }}
  />,
  <LayoutRoute
    exact={true}
    path={`${MarineInland.urls.opcionPago}/:idCotizacion?`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={MarineDatosResumen}
    validations={{
      prePolizaPagada: true,
    }}
  />,
  <LayoutRoute
    exact={true}
    path={`${MarineInland.urls.recuperar}/:idCotizacion?`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={MarineRecuperarCotizacion}
  />,
  <LayoutRoute
    exact={true}
    path={`${MarineInland.urls.emisionInfoEquipos}/:idCotizacion?`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={MarineInlandInfoadicionalEquipos}
  />,
  <LayoutRoute
    exact={true}
    path={`${MarineInland.urls.emisionContratante}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={MarineEmisionContratante}
    navBarTab="personas"
  />,

  <LayoutRoute
    exact={true}
    path={`${MarineInland.urls.vigenciaPoliza}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={MarineEmisionVigencia}
    navBarTab="personas"
  />,
];

export default MARINE_ROUTES;
